import auth from './auth/auth'
import gen from './gen'
import axios from 'axios'
import geo from 'geo-hash'
import haversine from 'haversine'
import common from './common/common'
import sha512 from 'js-sha512'
import {
  getFilteredPhotos, markExposure, getElsewherePics
} from '../../api'
import configurations from "../../configurations"


const state = {
  startAt: 0,
  limit: 50, // change limit
  filteredImagesArr: [],
  maxPhotos: 0,
  userGeohash: '',
  tempVar: false,
  fetchingImagesFromDb: false,
  lastVisible: `first_call`,
  fetchedPicsLength: null,
  morePhotos: true,
  flickrImageAvailability: false
}

const getters = {
  tempVar: state => state.tempVar,
  startAt: state => state.startAt,
  limit: state => state.limit,
  filteredImagesArr: state => state.filteredImagesArr,
  maxPhotos: state => state.maxPhotos,
  userGeohash: state => state.userGeohash,
  fetchedPicsLength: state => state.fetchedPicsLength,
  morePhotos: state => state.morePhotos
}

const mutations = {

  // get Elsewhere
  async getElsewherePics(state2, payload) {
    //
    if (payload.startAt == 0) {
      state.filteredImagesArr = []
      state.lastVisible = payload.lastVisible = payload.startAt === 0 ? 'first_call' : state.lastVisible
    }
    //console.log({USER_GEO: JSON.parse(payload.userGeo)})
    payload.addressIndex = []
    // payload.lastVisible = state.lastVisible
    state.fetchingImagesFromDb = true
    payload.isLoggedIn = auth.state.isLoggedIn,
      payload.uid = auth.state.user.uid,
      payload.sortBy === undefined ? payload.sortBy = 'random' :
        payload.sortBy === 'distance' ? payload.userGeo = JSON.parse(payload.userGeo) : delete payload['userGeo']
    payload.worldwide = true
    payload.emotionalAppeal = payload.emotionalAppeal
    payload.spotType = payload.spotType
    payload.keywords = payload.keywords
    payload.viewType = payload.viewType
    // payload.isCron = false,
    // payload.lastVisible = payload.startAt === 0? 'first_call': state.lastVisible
    //
    var d = new Date();
    let month = d.getMonth();
    let year = d.getFullYear();
    let date = d.getDate();
    let completeDate = date + "-" + month + "-" + year
    let seed = sha512(completeDate);
    let str = `${getFilteredPhotos}?`
    for (let i in payload) {
      str += `${i}=${typeof payload[i] !== 'string' ? JSON.stringify(payload[i]) : payload[i]}&`
    }
    str += 'seed=' + seed
    let s2 = str.substring(0, str.length - 1)

    let pics = await axios.get(s2)
    state.fetchedPicsLength = pics.data.photos.length;
    /*fetch(s2, {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer' + 'fdsdfsdfs'
      }
    })*/
    //
    // console.log(`pics -> `, pics)
    let response = pics.data
    state.fetchingImagesFromDb = false

    if (response.photos.length !== 0) {
      state.lastVisible = response.photos[response.photos.length - 1].id
      for (let i in response.photos) {
        if (response.photos[i] !== null) {
          //if(common.state.isModeSwipe) {
          let cloudinarySettings = configurations.cloudinary_settings;
          let img = new Image()
          if (response.photos[i].id !== null) {
            if (response.photos[i].id.match("^fse")) {
              let link = response.photos[i].photoSourceLink;
              let photoLinkH = link.replace("original", `height${screen.height}`)
              let photoLinkW = link.replace("original", `width${screen.width}`)
              img.src = photoLinkH;
              img.alt = `image`
              let img2 = new Image()
              img2.src = photoLinkW;
              img2.alt = `image`
            } else if (!!response.photos[i].propertyLink) {
              img.src = response.photos[i].photoSourceLink
              img.alt = `image`
              let img2 = new Image()
              img2.src = response.photos[i].photoSourceLink
              img2.alt = `image`
            }
            else {
              if (!!response.photos[i].flickrImageLink) {
                let flickrLink = mutations.getFlickrLink(response.photos[i].flickrImageLink, screen.height)
                if (mutations.flickrImageLinkAvailable(flickrLink)) {
                  img.src = flickrLink
                  img.alt = `image`
                  let img2 = new Image()
                  img2.src = mutations.getFlickrLink(response.photos[i].flickrImageLink, screen.width)
                  img2.alt = `image`
                } else {
                  img.src = `https://res.cloudinary.com/${configurations.cloudinary_cloudName}/image/upload/h_${screen.height},${cloudinarySettings}/${configurations.cloudinary_preset}/${response.photos[i].id}`
                  img.alt = `image`
                  let img2 = new Image()
                  img2.src = `https://res.cloudinary.com/${configurations.cloudinary_cloudName}/image/upload/w_${screen.width},${cloudinarySettings}/${configurations.cloudinary_preset}/${response.photos[i].id}`
                  img2.alt = `image`
                }
              } else {
                if(response.photos[i].propertyImages){
                  img.src = response.photos[i].photoSourceLink
                  img.alt = `image`
                  let img2 = new Image()
                  img2.src = response.photos[i].photoSourceLink
                  img2.alt = `image`                
                }
                if(response.photos[i].uploader === "user"){
                  img.src = `https://res.cloudinary.com/${configurations.cloudinary_cloudName}/image/upload/h_${screen.height},${cloudinarySettings}/${configurations.cloudinary_preset}/${response.photos[i].id}`
                  img.alt = `image`
                  let img2 = new Image()
                  img2.src = `https://res.cloudinary.com/${configurations.cloudinary_cloudName}/image/upload/w_${screen.width},${cloudinarySettings}/${configurations.cloudinary_preset}/${response.photos[i].id}`
                  img2.alt = `image`
                }
              
              }
            }

          }
          //}
          // img.src = `https://res.cloudinary.com/viewzzz/image/upload/w_auto/v1523306017/${response.photos[i].id}.jpg`

          state.filteredImagesArr.push(response.photos[i])
          // console.log('HERE IS GEOHASH', gen.state.finalUserLocation)
          // console.log('NOT IN IF==============>', gen.state.finalUserLocation, response.photos[i].shareSpotLocation.geohash)
          if (gen.state.finalUserLocation != '' &&
            Object.keys(response.photos[i].shareSpotLocation).length !== 0 &&
            gen.state.finalUserLocation != undefined &&
            response.photos[i].shareSpotLocation.geohash != "") {
            // console.log('GOING IN IF :(')
            let d1Lon = geo.decode(gen.state.finalUserLocation)
            let d1 = {latitude: d1Lon.lat, longitude: d1Lon.lon}
            let d2Lon = geo.decode(response.photos[i].shareSpotLocation.geohash)
            let d2 = {latitude: d2Lon.lat, longitude: d2Lon.lon}

            let distance = haversine(d1, d2)
            // console.log('DISTANCE=>', distance)
            state.filteredImagesArr[state.filteredImagesArr.length - 1].distance = `${distance.toFixed(0)} km`
          } else {
            state.filteredImagesArr[state.filteredImagesArr.length - 1].distance = '-- km'
          }
        }

        else
          break
      }
    }



    state.maxPhotos = state.filteredImagesArr.length

    //
  },
  async flickrImageLinkAvailable(photoLink) {
    this.flickrImageAvailability = false;
    await fetch(photoLink).then(
      response => {
        if (response.status < 400) {
          // console.log("Flickr image available");
          this.flickrImageAvailability = true;
        } else if (response.status === 403) {
          console.error("Flickr image available error");
          this.flickrImageAvailability = false;
        } else if (response.status === 404) {
          console.error("Flickr image not available");
          this.flickrImageAvailability = false;
        };
      }
    )
    return this.flickrImageAvailability;
  },
  getFlickrLink(photoLink, dimension) {
    if (dimension > 1200 && dimension < 1600) {
      return photoLink.replace("_o.", "_h.")
    } else if (dimension > 1600) {
      return photoLink.replace("_o.", "_k.")
    } else if (dimension < 1200 && dimension > 800) {
      return photoLink.replace("_o.", "_b.")
    } else if (dimension <= 800 && dimension > 640) {
      return photoLink.replace("_o.", "_c.")
    } else if (dimension <= 640) {
      return photoLink.replace("_o.", "_z.")
    }
  },
  // / get Elsewhere

  // async markExposure(state, payload) {
  //   console.log('PAYLOAD of markExposure', payload)
  //   let photoId = payload.id
  //   let uploaderId = payload.uploaderId
  //   let x1 = await axios.get(markExposure, {
  //     params: {
  //       photoId,
  //       uploaderId
  //     }
  //   })
  //   console.log('x1 res from mark exposure', x1)
  // },
  getLocation(state2) {
    common.state.fetchLocLoader = true
    // console.log('CALLING GET LOCATION')
    common.state.fetchLocLoader = false
    for (let i in state.filteredImagesArr) {
      // console.log('HERE IS GEOHASH', gen.state.finalUserLocation)
      // console.log('NOT IN IF==============>',i,  state.userGeohash, state)
      if (gen.state.finalUserLocation != ''
        && gen.state.finalUserLocation != undefined &&
        Object.keys(state.filteredImagesArr[i].shareSpotLocation).length !== 0 &&
        state.filteredImagesArr[i].shareSpotLocation.geohash != "") {
        // console.log('GOING IN IF :(')
        let d1Lon = geo.decode(gen.state.finalUserLocation)
        let d1 = {latitude: d1Lon.lat, longitude: d1Lon.lon}
        let d2Lon = geo.decode(state.filteredImagesArr[i].shareSpotLocation.geohash)
        let d2 = {latitude: d2Lon.lat, longitude: d2Lon.lon}

        let distance = haversine(d1, d2)
        let isM = false
        if (distance.toFixed(0) === '0') {
          isM = true
          distance = haversine(d1, d2, {unit: 'meter'})
        }
        // console.log('DISTANCE=>', distance)
        state.filteredImagesArr[i].distance = `${distance.toFixed(0)} ${isM ? ' m' : ' km'}`
      } else {
        state.filteredImagesArr[i].distance = '-- km'
      }
    }


    window.helloThis.$forceUpdate()

  },

  //
  goTo_uploadImage(state) {
    //
    if (!auth.state.isLoggedIn) {
      gen
        .mutations
        .goTo(state, '/Login')
    } else {
      gen
        .mutations
        .goTo(state, '/uploadImage_1')
    }
  },
  async getMainScreenImages(state2, payload) {

    //alert(`147`)
    // payload.isCron = false
    state.fetchingImagesFromDb = true
    // mutations.getLocation(state)
    // console.log('FILTER IMAGES=>', state.filteredImagesArr)
    // console.log('1=>', payload)
    //
    payload['isLoggedIn']
    delete payload['query']
    payload.sortBy !== 'distance' ? delete payload['userGeo'] : ''
    payload.addressIndex === undefined ? payload.addressIndex = [] : ''
    payload.sortBy === undefined ? payload['sortBy'] = 'random' :
      payload.sortBy === 'distance' ? payload.userGeo = JSON.parse(payload.userGeo) : delete payload['userGeo']
    payload.worldwide = false
    payload.emotionalAppeal = payload.emotionalAppeal
    payload.spotType = payload.spotType
    payload.keywords = payload.keywords

    // console.log('PAYLOAD:', payload)
    // payload.lastVisible = payload.startAt === 0? 'first_call': state.lastVisible
    //
    //let objSTR = JSON.stringify(payload)
    let str = `${getFilteredPhotos}?`
    for (let i in payload) {
      str += `${i}=${typeof payload[i] !== 'string' ? JSON.stringify(payload[i]) : payload[i]}&`
    }
    let s2 = str.substring(0, str.length - 1)
    let x1 = await axios.get(s2)
    if (payload.startAt == 0) {
      state.filteredImagesArr = []
      state.lastVisible = 'first_call'
    }
    // console.log('X1=>', x1)
    state.fetchingImagesFromDb = false
    let response = x1.data
    if (response.photos.length !== 0) {
      state.lastVisible = response.photos[response.photos.length - 1].id
      state.maxPhotos = response.totalPhotos
      for (let i in response.photos) {
        if (response.photos[i] !== null) {
          // if(common.state.isModeSwipe) {
          if (response.photos[i].id.match('^fse')) {
            let img = new Image()
            let link = response.photos[i].photoSourceLink
            img.src = link.replace("original", `width${screen.height}`)
            let img2 = new Image()
            img2.src = link.replace("original", `width${screen.width}`)
          }
          else {
            let cloudinarySettings = configurations.cloudinary_settings;
            let img = new Image()
            img.src = `https://res.cloudinary.com/${configurations.cloudinary_cloudName}/image/upload/h_${screen.height},${cloudinarySettings}/${configurations.cloudinary_preset}/${response.photos[i].id}`
            let img2 = new Image()
            img2.src = `https://res.cloudinary.com/${configurations.cloudinary_cloudName}/image/upload/w_${screen.width},${cloudinarySettings}/${configurations.cloudinary_preset}/${response.photos[i].id}`
          }
          // }
          state.filteredImagesArr.push(response.photos[i])
          //  console.log('HERE IS GEOHASH', gen.state.finalUserLocation)
          //  console.log('NOT IN IF==============>', gen.state.finalUserLocation, response.photos[i].shareSpotLocation.geohash)
          if (gen.state.finalUserLocation != '' && gen.state.finalUserLocation != undefined && response.photos[i].shareSpotLocation.geohash != "") {
            //  console.log('GOING IN IF :(')
            let d1Lon = geo.decode(gen.state.finalUserLocation)
            let d1 = {latitude: d1Lon.lat, longitude: d1Lon.lon}
            let d2Lon = geo.decode(response.photos[i].shareSpotLocation.geohash)
            let d2 = {latitude: d2Lon.lat, longitude: d2Lon.lon}

            let distance = haversine(d1, d2)
            let isM = false
            if (distance.toFixed(0) === '0') {
              isM = true
              distance = haversine(d1, d2, {unit: 'meter'})
            }
            state.filteredImagesArr[state.filteredImagesArr.length - 1].distance = `${distance.toFixed(0)} ${isM ? ' m' : ' km'}`
          } else {
            state.filteredImagesArr[state.filteredImagesArr.length - 1].distance = '-- km'
          }
        }
        else
          break
      }
    }
    else {
      state.morePhotos = false
    }
    // console.log('state.filteredImagesArr', state.filteredImagesArr)
    state.maxPhotos = state.filteredImagesArr.length
    // state.filteredImagesArr = x1.data
  }
}


export default {
  mutations,
  state,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/hello.js